import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { distance as formatDistance } from 'src/domains/sportsbook/utils/format';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { MarketTerms } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardMeta/MarketTerms';
import { RaceCardMetaPropsType } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardMeta/types';
import {
    RaceMetaData,
    RaceMetaDataEw,
    RaceMetaDataHandicap,
} from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardMeta/RaceCardMeta.style';

export const RaceCardMeta = observer(
    'RaceInfoMeta',
    ({ activeFilterId, nextRacesNew, race }: RaceCardMetaPropsType) => {
        const goingInfo = race.feedDataGoing ?? '';
        const handicapCond = race.feedHandicap === 'Y';
        const courseType = race.feedCourseType ?? '';
        const distance = formatDistance(race.feedDistance);

        return (
            <>
                {handicapCond && race.sportOriginal !== 'internationalhorseracing' ? (
                    <RaceMetaDataHandicap
                        data-test='race-header-item-meta-handicap'
                        nextRacesNew={nextRacesNew}
                    >
                        <I18n
                            langKey='events.handicap.label'
                            defaultText='Handicap'
                        />
                    </RaceMetaDataHandicap>
                ) : null}

                {courseType === '' ? null : (
                    <RaceMetaData
                        data-test='race-header-item-meta-course-type'
                        nextRacesNew={nextRacesNew}
                    >
                        {courseType}
                    </RaceMetaData>
                )}
                {distance === '' ? null : (
                    <RaceMetaData
                        data-test='race-header-item-meta-distance'
                        nextRacesNew={nextRacesNew}
                    >
                        {distance}
                    </RaceMetaData>
                )}
                {goingInfo === '' ? null : (
                    <RaceMetaData
                        data-test='race-header-item-meta-going-info'
                        nextRacesNew={nextRacesNew}
                    >
                        {goingInfo}
                    </RaceMetaData>
                )}

                <RaceMetaDataEw nextRacesNew={nextRacesNew}>
                    <MarketTerms
                        race={race}
                        activeFilterId={activeFilterId}
                        nextRacesNew={nextRacesNew}
                    />
                </RaceMetaDataEw>
            </>
        );
    }
);
